// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.simplert[data-v-618b40f9] {\n  z-index: 9000 !important;\n}\n\n", ""]);
// Exports
module.exports = exports;
